import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ExtractServiceRefreshType, RefreshTaskType } from '../../../schedule/serverApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { SelfServiceSchedule } from '../../../schedule/serverApi/types/SelfServiceSchedule';

export interface SetExtractTasksSelfServiceScheduleRequestParams {
  schedule: SelfServiceSchedule;
  type: RefreshTaskType | ExtractServiceRefreshType;
  scheduleName: string;
  ids: number[];
}

export class SetExtractTasksSelfServiceScheduleRequest extends Request<SetExtractTasksSelfServiceScheduleRequestParams, IResult> {
  constructor(params: SetExtractTasksSelfServiceScheduleRequestParams) {
    super('setExtractTasksSelfServiceSchedule', params);
  }
}
